'use client'

import { useRef } from 'react'
import { liteClient as algoliasearch } from 'algoliasearch/lite'
import { InstantSearchNext } from 'react-instantsearch-nextjs'

import GridArchiveInner from '@/components/grid-archive/GridArchiveInner'

import type { ArchiveAPIResponseType, FilterPropsType } from '@/layouts/types'

import { Configure } from 'react-instantsearch'

type GridProps = {
  algoliaIndex: string
  additionalTypes?: string[]
  filters?: FilterPropsType
  pillFilter?: string
  sidebarContent?: React.ReactNode
  pinnedPost?: ArchiveAPIResponseType['archive_pinned_post']
  queryString?: string
}

const searchClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY,
)

export default function GridArchiveWrapper({
  algoliaIndex,
  additionalTypes,
  filters,
  pillFilter,
  sidebarContent,
  pinnedPost,
  queryString,
}: GridProps): JSX.Element {
  const gridRef = useRef<HTMLDivElement>(null)

  const yesterdayUnix = Math.floor(Date.now() / 1000) - 86400
  let configureFilters = ` hide_date_unix>${yesterdayUnix} `

  // add post type filters to the all posts index if multiple are set
  if (
    algoliaIndex.includes('wp_searchable_posts') &&
    Array.isArray(additionalTypes) &&
    additionalTypes.length > 0
  ) {
    const postTypeFilter = additionalTypes.map((type) => ` post_type:"all-${type}" `).join(' OR ')

    if (postTypeFilter?.length) {
      configureFilters += ` AND (${postTypeFilter}) `
    }
  }

  // Allow custom algolia query string to be passed in to change the main query
  if (queryString) {
    configureFilters += queryString
  }

  return (
    <InstantSearchNext
      searchClient={searchClient}
      indexName={algoliaIndex}
      routing
      future={{
        preserveSharedStateOnUnmount: true,
        persistHierarchicalRootCount: true,
      }}>
      {configureFilters ? <Configure filters={configureFilters} /> : null}

      <GridArchiveInner
        filters={filters}
        pillFilter={pillFilter}
        sidebarContent={sidebarContent}
        pinnedPost={pinnedPost}
        gridRef={gridRef}
      />
    </InstantSearchNext>
  )
}
